const listHeaders = document.querySelectorAll('.best-time-open-list-header');
const BEST_TIME_PLUS_ICON = 'https://cdn.shopify.com/s/files/1/0928/3882/2261/files/grey-plus.svg?v=1762443731';
const BEST_TIME_CLOSE_ICON = 'https://cdn.shopify.com/s/files/1/0928/3882/2261/files/close.svg?v=1762955826';

function getBestTimeToggleIcon(headerEl) {
  if (!headerEl) return null;
  // знайти іконку-перемикач: це безпосередній <img> у header (не той, що всередині header-block)
  const children = Array.from(headerEl.children);
  for (let i = children.length - 1; i >= 0; i--) {
    if (children[i] && children[i].tagName === 'IMG') return children[i];
  }
  return null;
}
function setBestTimeIcon(headerEl, isOpen) {
  const icon = getBestTimeToggleIcon(headerEl);
  if (!icon) return;
  icon.src = isOpen ? BEST_TIME_CLOSE_ICON : BEST_TIME_PLUS_ICON;
}
// Ініціалізація іконок при завантаженні (на основі .active)
document.querySelectorAll('.best-time-open-list').forEach(block => {
  const header = block.querySelector('.best-time-open-list-header');
  const isActive = block.classList.contains('active');
  setBestTimeIcon(header, isActive);
});

listHeaders.forEach(header => {
  header.addEventListener('click', () => {
    const parent = header.parentElement;
    const isActive = parent.classList.contains('active');

    // Закриваємо всі блоки
    document.querySelectorAll('.best-time-open-list').forEach(block => {
      block.classList.remove('active');
      const h = block.querySelector('.best-time-open-list-header');
      setBestTimeIcon(h, false);
    });

    // Якщо блок був неактивним, відкриваємо його
    if (!isActive) {
      parent.classList.add('active');
      setBestTimeIcon(header, true);
    }
    // Якщо був активним — нічого не додаємо, залишиться закритим
  });
});